/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';

class OfficePage {
    constructor() {
        let hoursElem = $('.hero-hours-list');
        if (hoursElem.length > 0) {
            this.hoursModalLeft = hoursElem.position().left;
        }
    }

    init() {
        this.bindEvents();
    }

    centerArrow() {
        let arrow = $('.arrow-down');
        let arrowDown = $('.arrow-point');
        let modal = $('.hero-hours-list');
        let data = $(arrowDown).position().left - 3;
        $(arrow).css('left', data);
        $(arrow).css('top', '-50px');

        if (($(arrowDown).position().left - 200 > this.hoursModalLeft) && $(window).width() > 568) {
            $('.hero-hours-list').css('left', $(arrowDown).position().left - 200);
        }
        if (
            ($(arrowDown).position().left - 270 > this.hoursModalLeft) 
            && $(window).width() < 568
        ) 
        {
            $('.hero-hours-list').css('left', $(arrowDown).position().left - 270);
        }
    }

    bindEvents() {
        $('.js-header-office .btn-careers').attr('target', '_blank');
        $('.arrow-down').css('display', 'block');
        $('.arrow-down').css('opacity', '0');
        $('.hero-hours').on('focusin', (e) => {
            $('.hero-hours-list').show();
            this.centerArrow();
            $('.arrow-down').css('opacity', '1');
            this.popupOpen = true;
            $('.hero-hours-list').trigger('focus');
            e.stopPropagation();
        });

        $('body').on('click', (e) => {
            if (!$(e.target).closest('.hero-hours-list').length)
            {
                $('.hero-hours-list').hide();
                $('.arrow-down').css('opacity', '0');
                this.popupOpen = false;      
            }
        });
        $('.hero-hours').on('focusout', () => {
            $('.hero-hours-list').hide();
            $('.arrow-down').css('opacity', '0');
            this.popupOpen = false;
        });
        $('.hero-hours').on('click', (e) => {
            $('.hero-hours-list').show();
            this.centerArrow();
            $('.arrow-down').css('opacity', '1');
            this.popupOpen = true;
            $('.hero-hours-list').trigger('focus');
            e.stopPropagation();
        });
        $('.js-hours-close').on('click', () => {
            $('.hero-hours-list').hide();
            $('.arrow-down').css('opacity', '0');
            this.popupOpen = false;
        });

        $(window).on('load', () => {
            if ($('.js-read').height() >= 1000) {
                $('.js-read').addClass('readmore');
                let $expandButton = $('<div class="js-read-more">Load More</div>');
                let $fadingSpan = $('<span class="fading-bottom"></span>');
                $('.whats-happening-wrapper').append($expandButton);
                $('.js-read').append($fadingSpan);

                $('.js-read-more').click((e) => {
                    // record if our text is expanded
                    let isExpanded = $(e.target).hasClass('expand');

                    if (isExpanded) {
                        //close all open paragraphs
                        $('.readmore.expand').removeClass('expand');
                        $('.js-read-more.expand').removeClass('expand');
                        $('.fading-bottom.expand').removeClass('expand');
                        $('.js-read-more.expand').text('Load More');
                    }

                    // if target wasn't expand, then expand it
                    if (!isExpanded) {
                        $('.js-read').addClass('expand');
                        $('.fading-bottom').addClass('expand');
                        $(e.target).addClass('expand');
                        $('.js-read-more.expand').text('Show Less');
                    }
                });
            }
            this.$officeIdLabel = $('label[for*="OfficeId_Value"]');
            this.$officeEmailLabel = $('label[for*="OfficeEmail_Value"]');
            this.$formId = $('form[id*="form-OfficeContactUsForm"]');
            this.$officeIdInput = $("input[id*='OfficeId_Value']");
            this.$officeEmailInput = $("input[id*='OfficeEmail_Value']");
                if (this.$formId) {
                this.$officeEmailLabel.parent().parent().hide();
                this.$officeIdLabel.parent().parent().hide();
                this.$officeIdInput.val(officeId);
                this.$officeEmailInput.val(officeEmail);
            }
        });
        $(window).keyup(e => {
            if (e.key === 'Escape') {
                $('.hero-hours-list').hide();
                this.popupOpen = false;
            }
        });
        $(window).on('click', (e) => {
            const target = $(e.target);
            const parent = target.parents('.hero-hours-list');
            let clickedOnClose = parent.length === 0;
            if ($(target).hasClass('hero-hours-list')) {
                clickedOnClose = false;
            }

            if (clickedOnClose && $('.hero-hours-list').is(':visible'))
            {
                $('.hero-hours-list').hide();
            }
        });

        function resetHoursModalPosition() 
        {
            $('.hero-hours-list').css('left', this.hoursModalLeft);            
        }

        //copying form into modal container and populate inputs email & officeId

        let $privacyText = '<div class="privacy-text"><span>By clicking Send Message, you acknowledge and agree to our <a href="/privacy">Privacy Policy.</a></span></div>';

        let emailValue = $('.form-wrapper').find('input[id*="OfficeEmail_Value"]').val();
        let officeIdValue = $('.form-wrapper').find('input[id*="OfficeId_Value"]').val();
        $('#js-add-form').find('input[id*="OfficeEmail_Value"]').val(emailValue);
        $('#js-add-form').find('input[id*="OfficeId_Value"]').val(officeIdValue);
        //
    }
}

export default OfficePage;

$(() => {
    const officePage = new OfficePage();
    officePage.init();
});